import React from 'react';

const statusColor = (problem, language) => {
  const saved = localStorage.getItem(`${language}_${problem.id}`);
  if (problem.submitted) return { ring: '#4CAF50', dot: '#4CAF50', label: '✓' };
  if (saved) return { ring: '#F59E0B', dot: '#F59E0B', label: '●' };
  return { ring: '#D1D5DB', dot: null, label: null };
};

const Toolbar = ({ problems, interview_id, onProblemClick, currentProblemId, language = 'python', submittedProblems = new Set() }) => {
  const solvedCount = submittedProblems.size;

  return (
    <div className="flex flex-col items-center gap-1 py-3 h-full">
      <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest mb-1">
        {solvedCount}/{problems.length}
      </span>
      <div className="w-8 h-px bg-gray-600 mb-2" />
      {problems.map((problem, index) => {
        const isActive = problem.id === currentProblemId;
        const isSubmitted = submittedProblems.has(problem.id);
        const hasCode = !!localStorage.getItem(`${language}_${problem.id}`);
        const ringColor = isSubmitted ? '#4CAF50' : hasCode ? '#F59E0B' : '#4B5563';

        return (
          <div key={problem.id} className="relative group" title={problem.title || `Problem ${index + 1}`}>
            <button
              onClick={() => onProblemClick(problem.id)}
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                border: `2.5px solid ${isActive ? 'transparent' : ringColor}`,
                background: isActive
                  ? 'linear-gradient(135deg, #ec4899, #3b82f6)'
                  : isSubmitted
                    ? 'rgba(74,222,128,0.1)'
                    : hasCode
                      ? 'rgba(251,191,36,0.1)'
                      : 'rgba(55,65,81,0.8)',
                color: isActive ? '#fff' : isSubmitted ? '#4CAF50' : hasCode ? '#F59E0B' : '#9CA3AF',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 14,
                fontWeight: 700,
                transition: 'all 0.2s ease',
                boxShadow: isActive ? '0 0 0 3px rgba(236,72,153,0.3)' : 'none',
              }}
            >
              {isSubmitted ? (
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2 7l4 4 6-6" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              ) : (
                index + 1
              )}
            </button>

            {/* Tooltip */}
            {problem.title && (
              <div className="absolute left-12 top-1/2 -translate-y-1/2 z-50 hidden group-hover:block pointer-events-none">
                <div className="bg-gray-900 text-white text-xs px-2 py-1 rounded-lg whitespace-nowrap shadow-xl border border-gray-700 max-w-[180px] truncate">
                  {problem.title}
                </div>
                <div className="absolute top-1/2 -left-1 -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-gray-900" />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Toolbar;
